import React, { useState, useEffect, useRef } from "react";
import { Form, Button } from "antd";
import ImageUploader from "./imageUploader";

import Select from "react-select";
import { Editor } from "@tinymce/tinymce-react";

import "./styles.scss";
import firebase from "firebase";

const FormOriginal = (props) => {
  const options = [
    { value: "all", label: "Tüm Ürünler" },
    { value: "kit", label: "Kitler" },
    { value: "icecek", label: "Kombucha İçeçekler" },
    { value: "cay", label: "Çaylar" },
    { value: "aromalar", label: "Aromalar" },
    { value: "siseleme", label: "Siseleme ve Kavanozlar" },
    { value: "yardimci", label: "Demleme Yardımcıları" },
  ];

  const { getFieldDecorator } = props.form;
  const [categ, setCategory] = useState("");
  const [content, setContent] = useState("");
  const [short, setShort] = useState("");
  const [bImage, setB] = useState("");
  const [image1, set1] = useState("");
  const [image2, set2] = useState("");
  const [image3, set3] = useState("");
  const handleUploadSuccess = (filename) => {
    setB(filename);
    //  this.setState({ avatar: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref("images")
      .child(filename)
      .getDownloadURL()
      .then((url) => setB(url));
  };
  const handleUploadSuccess1 = (filename) => {
    set1(filename);
    //  this.setState({ avatar: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref("images")
      .child(filename)
      .getDownloadURL()
      .then((url) => set1(url));
  };
  const handleUploadSuccess2 = (filename) => {
    set2(filename);
    //  this.setState({ avatar: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref("images")
      .child(filename)
      .getDownloadURL()
      .then((url) => set2(url));
  };
  const handleUploadSuccess3 = (filename) => {
    set3(filename);
    //  this.setState({ avatar: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref("images")
      .child(filename)
      .getDownloadURL()
      .then((url) => set3(url));
  };
  getFieldDecorator("keys", {
    initialValue: props.defaultValues,
  });

  useEffect(() => {
    // Update the document title using the browser API
    if (props.defaultValues) {
      setContent(props.defaultValues.longDescription);
      setB(props.defaultValues.bannerImage);
      set1(props.defaultValues.image1);
      set2(props.defaultValues.image2);
      set3(props.defaultValues.image3);
      setCategory(props.defaultValues.category);
      setShort(props.defaultValues.shortDescription);
      console.log("dasdasdSADA", props.defaultValues);
    }
  }, []);

  return (
    <div className="contactFormWrapper">
      <div
        style={{
          position: "absolute",
          width: "300px",
          height: "50px",
          backgroundColor: "#d35400",
          top: "-25px",
          left: "100px",
          borderRadius: "15px 50px",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <span
          style={{
            color: "#fff",
            fontSize: "30px",
            fontFamily: "Source Sans Pro",
          }}
        >
          {props.title}
        </span>
      </div>
      <form
        className="contactForm"
        onSubmit={(e) => props.handleSubmit(e, props.form)}
      >
        <div
          style={{
            alignItems: "flex-start",
            justifyContent: "center",
            display: "flex",
            flexDirection: "row-reverse",
            width: "90%",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "10px",
              justifyContent: "flex-start",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <ImageUploader
                title="Ana Resim"
                imageUrl={bImage}
                success={handleUploadSuccess}
              />
              <ImageUploader
                title="Ikinci Resim"
                imageUrl={image1}
                success={handleUploadSuccess1}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <ImageUploader
                title="Ucuncu Resim"
                imageUrl={image2}
                success={handleUploadSuccess2}
              />
              <ImageUploader
                title="Dorduncu Resim"
                imageUrl={image3}
                success={handleUploadSuccess3}
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              width: "100%",
            }}
          >
            <Form.Item style={{ width: "100%" }} label="Urun Ismi">
              {getFieldDecorator("name", {
                initialValue: props.defaultValues && props.defaultValues.name,
                rules: [
                  { required: true, message: "Lutfen urun ismini giriniz" },
                ],
              })(
                <input
                  style={{ height: "50px" }}
                  placeholder="Urun Ismi"
                  className="contactFormInput"
                />
              )}
            </Form.Item>
            <div
              style={{ display: "flex", width: "100%", flexDirection: "row" }}
            >
              <Form.Item
                style={{ width: "100%", marginRight: "20px" }}
                label="Indirim Orani %"
              >
                {getFieldDecorator("discount", {
                  initialValue:
                    props.defaultValues && props.defaultValues.discountRate,
                  rules: [
                    {
                      required: true,
                      message: "Lutfen indirim oranini giriniz (0-100)",
                    },
                  ],
                })(
                  <input
                    style={{ height: "50px" }}
                    placeholder="0-100"
                    className="contactFormInput"
                  />
                )}
              </Form.Item>
              <Form.Item
                style={{ width: "100%", marginRight: "20px" }}
                label="Stok Miktari"
              >
                {getFieldDecorator("stock", {
                  initialValue:
                    props.defaultValues && props.defaultValues.stockAmount,
                  rules: [
                    {
                      required: true,
                      message: "Lutfen stok giriniz (0-1000)",
                    },
                  ],
                })(
                  <input
                    style={{ height: "50px" }}
                    placeholder="0-1000"
                    className="contactFormInput"
                  />
                )}
              </Form.Item>
              <Form.Item style={{ width: "100%" }} label="Ürün Kodu">
                {getFieldDecorator("productCode", {
                  initialValue:
                    props.defaultValues && props.defaultValues.productCode,
                  rules: [
                    {
                      required: true,
                      message: "Lütfen Ürün Kodu Giriniz",
                    },
                  ],
                })(
                  <input
                    style={{ height: "50px" }}
                    placeholder="Ürün Kodu"
                    className="contactFormInput"
                  />
                )}
              </Form.Item>
            </div>
            <Form.Item style={{ width: "100%" }} label="Kategori">
              {getFieldDecorator("categ", {
                initialValue: options.filter(
                  (option) => option.value === categ
                ),

                rules: [
                  {
                    required: true,
                    message: "Lütfen kategori seçiniz!",
                  },
                ],
              })(
                <Select
                  value={options.filter((option) => option.value === categ)}
                  tabSelectsValue={categ}
                  onChange={(option) => setCategory(option.value)}
                  options={options}
                  style={{
                    zIndex: "9999999",
                    width: "100%",
                    height: "50px",
                    fontFamily: "Source Sans Pro",
                    color: "#1d1d1d",
                    fontWeight: "500",
                    fontSize: " 17px",
                  }}
                />
              )}
            </Form.Item>
            <Form.Item style={{ width: "100%" }} label="Kisa Aciklama">
              {getFieldDecorator("shortDesc", {
                initialValue:
                  props.defaultValues && props.defaultValues.shortDescription,
                rules: [
                  {
                    required: true,
                    message: "Lütfen ürün kısa açıklamasını giriniz!",
                  },
                ],
              })(
                <textarea
                  style={{ height: "150px" }}
                  placeholder="Urun Kisa Aciklamasi"
                  className="contactFormInput"
                />
              )}
            </Form.Item>
            <Form.Item style={{ width: "100%" }} label="Fiyat">
              {getFieldDecorator("price", {
                initialValue: props.defaultValues && props.defaultValues.price,

                rules: [
                  {
                    required: true,
                    message: "Please input your product description!",
                  },
                ],
              })(<input placeholder="00.00₺" className="contactFormInput" />)}
            </Form.Item>

            {getFieldDecorator("bannerImage", {
              initialValue: bImage,
            })}
            {getFieldDecorator("image1", {
              initialValue: image1,
            })}
            {getFieldDecorator("image2", {
              initialValue: image2,
            })}
            {getFieldDecorator("image3", {
              initialValue: image3,
            })}

            {getFieldDecorator("longdesc", {
              initialValue: content,
            })}
            {getFieldDecorator("cat", {
              initialValue: categ,
            })}
          </div>
        </div>
        <div style={{ display: "flex", width: "90%", margin: "0 auto" }}>
          <Form.Item style={{ width: "100%" }} label="Urun Uzun Aciklamasi">
            <Editor
              apiKey="s825g6h8k9anaemejf0288g84rkn8sjlcskvbnhu7y00uphp"
              initialValue={content}
              init={{
                height: 600,
                menubar: true,
                plugins: [
                  "advlist autolink lists link image charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code help wordcount",
                ],
                toolbar:
                  "undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help",
              }}
              onEditorChange={(a) => setContent(a)}
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Form.Item style={{ display: "flex" }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                width: "500px",
                height: "80px",
                backgroundColor: "#27ae60",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                alignSelf: "center",
                borderRadius: "5px",
                boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
                margin: "50px auto",
              }}
            >
              {props.type}
            </Button>
          </Form.Item>
        </div>
      </form>
    </div>
  );
};
const WrappedNormalLoginForm = Form.create({ name: "productCreate" })(
  FormOriginal
);

export default WrappedNormalLoginForm;
